// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/front-page.scss
// module id = 13
// module chunks = 3